import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AIToolsCompare from "../components/AIToolsCompare";
import AIToolsPrompts from "../components/AIToolsPrompts";

export default function AIToolsPage() {
  const [activeTab, setActiveTab] = useState("prompts");
  const navigate = useNavigate();

  return (
    <div>
      <div className="howtos-header" style={{ marginTop: '50px', marginBottom: '30px' }}>
        <span className="howtos-badge">AI Workspace Insights</span>
        <h1>Ultimate <span>Workflow Enhancements</span></h1>
        <p>Review standard parameters and access optimized coding sequences below.</p>
      </div>

      {/* Dynamic Module Tabs */}
      <div className="module-tabs">
        <button 
          className={`module-tab ${activeTab === "compare" ? "active" : ""}`}
          onClick={() => setActiveTab("compare")}
        >
          Compare AI Tools
        </button>
        <button 
          className={`module-tab ${activeTab === "prompts" ? "active" : ""}`}
          onClick={() => setActiveTab("prompts")}
        >
          Prompt Recipes Hub
        </button>
      </div>

      <div style={{ paddingBottom: '60px' }}>
        {activeTab === "compare" && <AIToolsCompare />}
        {activeTab === "prompts" && <AIToolsPrompts />}
      </div>
    </div>
  );
}

